<div class="container mt-3">
  <blockquote class="blockquote bq-danger">
    <p class="bq-title">
      {{ Localization.AccountConfirmationFailed | translate}}
    </p>
    <p>
      {{ Localization.PleaseContactWithAdministrator | translate}}
    </p>
  </blockquote>
</div>
